<template>
  <div class="container">
    <h2 class="mb-5">Collection details</h2>
    <form
      name="test"
      style="margin: 0 auto; max-width: 700px;"
      @submit.prevent="onSubmit"
    >
      <base-select
        :class="{'select-green': dataFromLastSubmissionCompany }"
        name="company"
        v-validate="'required'"
        label="Company"
        select-label="name"
        v-model="company"
        :options="userCompanies"
        :err="formErrors.company"
        :disabled="!canEdit"
      />

      <base-date
        name="month"
        v-validate="'required'"
        label="Month of processing"
        v-model="collectionDate"
        format="DD-MM-YYYY"
        :err="formErrors.month"
        :disabled="!canEdit"
        :monthOnly="true"
      />

      <base-select
            v-if="user.is_input"
            :class="{'select-green': dataFromLastSubmissionCountry }"
            select-label="name"
            name="country"
            v-validate="'required'"
            label="Country of collection"
            v-model="country"
            :options="countries"
            :err="formErrors.country"
            :disabled="!canEdit"
      />

      <base-select
        name="composition"
        v-validate="'required'"
        :label="this.user.is_input ? 'Waste name' : 'Product name'"
        v-model="composition"
        :options="filteredUserCompanyCompositions"
        select-label="human_name"
        secondary-label="name"
        :err="formErrors.composition"
        :disabled="!canEdit"
      >
        <template
          slot="right-container"
        >
          <base-button
            :style-type="'btn-block'"
            component-class="blue style-250 mt-2 mt-xl-0 btn-block"
            @click.native="manageCompositions"
            v-if="canEdit"
          >
            {{ this.user.is_input ? 'New waste' : 'New composition' }}
          </base-button>
        </template>
      </base-select>
      <base-text
        name="volume"
        v-validate="'required|decimal|min_value:0'"
        :label="`Volume (${getWeightUnit})`"
        v-model="volumeGross"
        :err="formErrors.volume"
        :disabled="!canEdit"
      />

      <base-text
        v-show="user.is_input"
        name="contamination"
        label="Contamination"
        v-model="contamination"
        :units="{units: [getWeightUnit, '%'], source: contaminationUnits}"
        @input-unit="handleOnUnitChange"
        :err="errors.collect('contamination')"
        :disabled="!canEdit"
      />

      <base-text
        name="volume_net"
        :label="`Net volume (${getWeightUnit})`"
        v-model="volumeNet"
        :readonly="true"
      />

      <!-- <base-text-area
        name="comments"
        label="Comments"
        v-model="comments"
        :err="errors.collect('comments')"
        :disabled="!canEdit"
      /> -->
      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button
            radius="bl"
            component-class="blue"
            @click.native="$router.go(-1)"
          ><i class="fas fa-arrow-left mr-3"></i> Back
          </base-button>
        </div>
        <div
          class="col-6 text-right"
        >
          <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            v-if="canEdit"
          >Save <i class="fas fa-arrow-right ml-3"></i>
          </base-button>
          <!-- <pre>{{isContaminationInPreview}}</pre> -->
          <!-- <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            v-if="canEdit"
            :disabled="!isValid"
          >Next <i class="fas fa-arrow-right ml-3"></i>
          </base-button> -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import { mapState, mapActions, mapGetters } from 'vuex';
  import { roundToTwo } from '@/helpers/math';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseDate from '@/components/inputs/text/BaseDate';
  // import BaseTextArea from '@/components/inputs/text/BaseTextArea';
  import BaseSelect from '@/components/inputs/select/BaseSelect';
  import BaseButton from '@/components/inputs/button/BaseButton';
  import constances from '@/configs/constances';

  export default {
    data() {
      return {
        constances,
        submissionId: null,
        company: null,
        collectionDate: '',
        composition: null,
        volumeGross: null,
        contamination: 0,
        volumeNet: null,
        country: '',
        // comments: '',
        contaminationUnits: null,
        currentSubmission: {},
        formErrors: {
          company: [],
          month: [],
          composition: [],
          volume: []
        },
        dataFromLastSubmissionCompany: false,
        dataFromLastSubmissionCountry: false,
        recycledMaterialsValue: 0,
        fromRouteName: ''
      };
    },
    computed: {
      user () {
        return this.$store.getters['user/user'];
      },
      ...mapState({
        userCompanies: state => state.userCompanies.loggedUserCompanies,
        userCompanyCompositions: state => state.userCompositions.companyCompositions,
        userSubmission: state => state.userSubmissions.data,
        countries: state => state.countries.countries,
      }),
      ...mapGetters({
        userId: 'user/getLoggedInUserId',
      }),
      canEdit() {
        if (!this.currentSubmission.id) {
          return true;
        }

        const days = moment().diff(moment(this.currentSubmission.createdAt), 'days');
        return days <= this.constances.submissionCanEditByDays;
      },
      // isContaminationInPreview() {
      //   const isPreview = this.canEdit === false;
      //   const isContamination = parseInt(this.contamination, 0) === 0 || isNaN(parseInt(this.contamination, 0));

      //   return isContamination && isPreview;
      // },
      filteredUserCompanyCompositions() {
        if (this.company) {
          return this.userCompanyCompositions.filter(composition => this.company.id === composition.company_id);
        }
        return [];
      },
      getWeightUnit() {
        return this.$store.getters['user/getWeightUnit'];
      },
      isValid() {
        let isValid = true;
        const validatorObject = this.$validator.flags;
        Object.keys(validatorObject).forEach(key => {
          if (!validatorObject[key].valid) {
            isValid = false;
          }
        });
        return isValid;
      },
      getUserLastSubmittedData() {
        return {
          userSubmission: this.userSubmission,
          userCompanies: JSON.parse(JSON.stringify(this.userCompanies)),
          countries: this.countries,
        };
      }
    },

    watch: {
      getWeightUnit(newValue) {
        this.contaminationUnits = newValue;
      },
      countries(newValue) {
        if (this.currentSubmission.country_code) {
          this.country = newValue.filter(country => country.code === this.currentSubmission.country_code)[0];
        }
      },
      volumeGross(newValue) {
        const volumeGrossValue = this.calculateNetVolume(this.contaminationUnits, newValue, this.contamination);
        this.volumeNet = volumeGrossValue;
      },
      contamination(newValue) {
        this.volumeNet = this.calculateNetVolume(this.contaminationUnits, this.volumeGross, newValue);
      },
      userSubmission(newValue) {
        const currentSubmission = newValue.filter(submission => submission.id === this.submissionId)[0];
        if (currentSubmission) {
          this.currentSubmission = currentSubmission;
          this.collectionDate = moment(currentSubmission.collection_date, 'YYYY-MM-DD').format('DD-MM-YYYY');
          this.volumeGross = this.volumeByWeightUnit(currentSubmission.volume_gross);
          this.contamination = this.volumeByWeightUnit(currentSubmission.volume_gross - currentSubmission.volume_net);
          // this.comments = currentSubmission.comments;
          this.contaminationUnits = this.getWeightUnit;
        }
      },
      userCompanies(newValue) {
        if (this.currentSubmission.company_id) {
          this.company = newValue.filter(company => company.id === this.currentSubmission.company_id)[0];
        }
      },
      filteredUserCompanyCompositions(newValue) {
        if (this.currentSubmission.composition_id) {
          this.composition = newValue.filter(composition => composition.id === this.currentSubmission.composition_id)[0];
        }
      },
      getUserLastSubmittedData(newValue) {
        if (!this.submissionId && !this.getMemoData()) {
          const { userSubmission, userCompanies, countries } = newValue;
          const lastUserSubmission = userSubmission.filter(submission => submission.user_id === this.userId).pop();
          if (lastUserSubmission) {
            this.setLastUserSubmissionCompany(lastUserSubmission, userCompanies);
            this.setLastUserSubmissionCountry(lastUserSubmission, countries);
            this.dataFromLastSubmissionCompany = true;
            this.dataFromLastSubmissionCountry = true;
          } else {
            this.company = userCompanies[0];
            this.dataFromLastSubmissionCompany = true;
          }
        }
      },
      composition(newValue) {
        if (newValue) {
          const recycledMaterials = newValue.materials
            .reduce((previouseValue, currentValue) => {
              return previouseValue + currentValue.percentage;
            }, 0);
          this.recycledMaterialsValue = recycledMaterials;
        }
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.fromRouteName = from;
        });
    },
    methods: {
      ...mapActions({
        getUserCompanyCompositions: 'userCompositions/companyCompositions',
        // getUserCompanies: 'userCompanies/getCompanies',
        getUserAttachedCompany: 'userCompanies/getUserAttachedCompany',
        getCompositions: 'userCompositions/getCompositions',
        getUserSubmissions: 'userSubmissions/getSubmissions',
        getCountries: 'countries/getCountries',
      }),
      setLastUserSubmissionCompany(lastUserSubmission, userCompanies) {
        const lastUserSubmissionCompany = userCompanies.filter(company => company.id === lastUserSubmission.company_id)[0];
        this.company = lastUserSubmissionCompany;
      },
      setLastUserSubmissionCountry(lastUserSubmission, countries) {
        if (! countries) {
          this.country = '';
        }
        const lastUserSubmissionCountry = countries.filter(country => country.code === lastUserSubmission.country_code)[0];
        this.country = lastUserSubmissionCountry;
      },
      manageCompositions () {
        this.setMemoData();
        this.$router.push({name: 'user.composition-list'});
      },
      getValueOfPercent(value, percent) {
        return percent / 100 * value;
      },
      calculateNetVolume(unit, volumeGross, contamination) {
        let volumeNet = this.volumeGross;
        let contaminationValue = contamination;

        if (typeof contaminationValue === 'string') {
          contaminationValue = contaminationValue.replace(/,/g, '.');
        }
        if (typeof volumeNet === 'string') {
          volumeNet = volumeNet.replace(/,/g, '.');
        }

        if (this.contamination) {
          if (unit === this.getWeightUnit) {
            volumeNet = roundToTwo(volumeNet - contaminationValue);
          } else {
            volumeNet = roundToTwo(volumeNet - this.getValueOfPercent(volumeNet, contaminationValue));
          }
        }

        return volumeNet;
      },
      handleOnUnitChange(unit) {
        this.contaminationUnits = unit;
        this.volumeNet = this.calculateNetVolume(this.contaminationUnits, this.volumeGross, this.contamination);
      },
      volumeByWeightUnit(volume) {
        if (this.getWeightUnit === 'ton') {
          return volume / 1000;
        }
        return volume;
      },
      async displayErrors() {
        this.formErrors = {
          company: [],
          country: [],
          month: [],
          composition: [],
          volume: []
        };
        const errors = await this.$validator.errors.items;
        errors.forEach((error) => {
          this.formErrors[error.field] = [error.msg];
          console.log(error, error.field, error.msg);
        });
      },
      async onSubmit () {
        const isFormValid = await this.$validator.validateAll();
        await this.displayErrors();
        if (isFormValid) {
          let volumeGross = this.volumeGross;
          let volumeNet = this.volumeNet;
          if (this.getWeightUnit === 'ton') {
            volumeGross = volumeGross * 1000;
            volumeNet = volumeNet * 1000;
          }

          const [day, month, year] = this.collectionDate.split('-');

          const submissionData = {
            submission_id: this.submissionId,
            company_id: this.company.id,
            country_code: this.user.is_input ? this.country.code : null,
            composition_id: this.composition.id,
            collection_date: `${year} ${month} ${day}`,
            volume_gross: volumeGross,
            volume_net: volumeNet,
            // comments: this.comments,
          };

          if (this.submissionId) {
            this.$store.dispatch('userSubmissions/update', submissionData).then(() => {
              this.$router.push({name: 'user.dashboard'});
            });
          }
          else {
            this.$store.dispatch('userSubmissions/save', submissionData).then(() => {
              this.$router.push({name: 'user.dashboard'});
              this.$snotify.success('Submission saved.');
            });
          }
        }
      },
      setMemoData() {
        const memoData = {
          company: this.company,
          country: this.country,
          collectionDate: this.collectionDate,
          composition: this.composition,
          volumeGross: this.volumeGross,
          contamination: this.contamination,
          contaminationUnits: this.contaminationUnits,
          volumeNet: this.volumeNet,
          // comments: this.comments
        };
        sessionStorage.setItem('memoSubmission', JSON.stringify(memoData));
      },
      getMemoData() {
        return JSON.parse(sessionStorage.getItem('memoSubmission'));
      },
      apllyMemoData() {
        const memoData = this.getMemoData();
        if (memoData) {
          this.company = memoData.company;
          this.country = memoData.country;
          this.collectionDate = memoData.collectionDate;
          this.composition = memoData.composition;
          this.volumeGross = memoData.volumeGross;
          this.volumeNet = memoData.volumeNet;
          this.contaminationUnits = memoData.contaminationUnits;
          this.contamination = parseInt(memoData.contamination, 0);
          // this.comments = memoData.comments;
          setTimeout(() => {
            sessionStorage.removeItem('memoSubmission');
          }, 300);
        }
      }
    },

    async mounted () {
      this.submissionId = parseInt(this.$route.params.id, 0);
      await this.getUserSubmissions();

      // this.getUserCompanies(this.$store.getters['user/getLoggedInUserId']);
      await this.getUserAttachedCompany(this.$store.getters['user/getLoggedInUserId']);
      await this.getCountries();
      await this.getUserCompanyCompositions();

      // tutaj sprawdzimy przy edycji!!!
      const collectionDate = this.collectionDate || moment(new Date());
      this.collectionDate = moment(collectionDate, 'MM-YYYY').format('MM-YYYY');
      this.contaminationUnits = this.getWeightUnit;

      this.apllyMemoData();
    },

    components: {
      'base-text': BaseText,
      'base-date': BaseDate,
      'base-select': BaseSelect,
      'base-button': BaseButton,
      // 'base-text-area': BaseTextArea,
    }
  };

</script>
